// extracted by mini-css-extract-plugin
module.exports = {"root":"control-column_root__2pRMS","icons":"control-column_icons__1JlWX"};